import { loginStore } from '../state/CommonState'
import RoleUtils from '../util/RoleUtils'
import { PERMISSIONS_NEW } from '../util/constants'

// Users listed in REACT_APP_STAFF_HOME_USERS (the pilot).
function onPilot() {
  const me = String(loginStore.userRec?.aguserRec?.email ?? '').trim().toLowerCase()
  const pilot = String(process.env.REACT_APP_STAFF_HOME_USERS ?? '').toLowerCase().split(',').map((s) => s.trim()).filter(Boolean)
  return me !== '' && pilot.includes(me)
}

// Data Discrepancies is shown to users on the pilot list or to anyone with the MH01 permission.
// MH01 is read when called (left menu render), so it depends on rolePermissionsList already being loaded.
export function isStaffHomeUser() {
  if (loginStore.isClient()) return false
  return onPilot() || RoleUtils.isUserAuthorized(PERMISSIONS_NEW.DATA_DISCREPANCIES.VIEW)
}

// CRM Analytics: the MH02 permission, or the same pilot list. The tower still decides what each user may see (403 = none).
export function isCrmUser() {
  if (loginStore.isClient()) return false
  return onPilot() || RoleUtils.isUserAuthorized(PERMISSIONS_NEW.CRM_ANALYTICS.VIEW)
}
